<template>
  <div class="container-fluid">
    <section class="setting">
      <div class="divider divider-left" style="margin: 15px 0px 15px 15px">
        <div class="divider-line" style="height: 2px;"></div>
        <span style="font-size: 18px; padding: 4.5px 18px 4.5px 0px">
          歡迎與感謝頁面
        </span>
      </div>
      <section class="content">
        <div class="form-filed">
          <div class="form-label">
            <div class="setting-label">問卷名稱</div>
          </div>
          <div class="filed-control">
            <input maxlength="200" class="input-primary input-style" />
          </div>
        </div>
        <div class="form-filed">
          <div class="form-label">
            <div class="setting-label">歡迎文字</div>
          </div>
          <div class="filed-control">
            <VueEditor style="background: rgb(255, 255, 255);" />
          </div>
        </div>
        <div class="form-filed">
          <div class="form-label">
            <div class="setting-label">感謝文字</div>
          </div>
          <div class="filed-control">
            <VueEditor style="background: rgb(255, 255, 255);" />
          </div>
        </div>
        <div class="form-filed">
          <div class="form-label">
            <div class="setting-label">頁面背景圖片</div>
          </div>
          <div class="filed-control">
            <el-upload class="upload-demo mt-2" action="">
              <el-button size="small" type="primary">上傳圖片</el-button>
              <div slot="tip" class="el-upload__tip mark">
                僅能上傳 jpg/png 檔案，且大小不超過 500kb
              </div>
            </el-upload>
          </div>
        </div>
        <div class="form-filed">
          <div class="form-label">
            <div class="setting-label">歡迎 Bannner</div>
          </div>
          <div class="filed-control">
            <el-upload class="upload-demo mt-2" action="">
              <el-button size="small" type="primary">上傳圖片</el-button>
              <div slot="tip" class="el-upload__tip mark">
                僅能上傳 jpg/png 檔案，且大小不超過 500kb
              </div>
            </el-upload>
          </div>
        </div>
        <div class="form-filed">
          <div class="form-label">
            <div class="setting-label">感謝 Bannner</div>
          </div>
          <div class="filed-control">
            <el-upload class="upload-demo mt-2" action="">
              <el-button size="small" type="primary">上傳圖片</el-button>
              <div slot="tip" class="el-upload__tip mark">
                僅能上傳 jpg/png 檔案，且大小不超過 500kb
              </div>
            </el-upload>
          </div>
        </div>
      </section>

      <div class="divider divider-left" style="margin: 15px 0px 15px 15px">
        <div class="divider-line" style="height: 2px;"></div>
        <span style="font-size: 18px; padding: 4.5px 18px 4.5px 0px">
          一般設定
        </span>
      </div>
      <section class="content">
        <div class="form-filed">
          <div class="form-label">
            <div class="setting-label">問卷有效期限 (起)</div>
          </div>
          <div class="filed-control">
            <date-picker class="w-25" format="YYYY-MM-DD" valueType="format">
            </date-picker>
          </div>
        </div>
        <div class="form-filed">
          <div class="form-label">
            <div class="setting-label">問卷有效期限 (訖)</div>
          </div>
          <div class="filed-control">
            <date-picker class="w-25" format="YYYY-MM-DD" valueType="format">
            </date-picker>
          </div>
        </div>
      </section>
    </section>

    <div class="button-group">
      <button type="button" class="btn button-grey" @click="$router.go(-1)">取消</button>
      <button type="button" class="btn button-green" @click="createNewForm">建立題目</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    createNewForm() {
      this.$router.push({ path: "/manager/survey/new" });
    },
  },
};
</script>


<style lang="scss" scoped>
.container-fluid {
  width: 100%;
  background-color: #fff;
}
.setting {
  display: block;
  position: relative;
  .divider {
    z-index: 0 !important;
    position: relative;
    display: block;
    .divider-line {
      position: absolute;
      content: "";
      z-index: 1;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      background: #3dba90;
    }
    & > span {
      display: inline-block;
      position: relative;
      z-index: 2;
      color: #3dba90;
      background: #fff;
      font-weight: 700;
    }
  }
  .divider-left {
    text-align: left;
  }
  .content {
    padding: 0 30px;
    .form-filed {
      display: inline-block;
      position: relative;
      width: 100%;
      height: auto;
      margin-bottom: 6px;
      padding: 6px 0;
      font-size: 14px;
      min-height: 1px;
      box-sizing: border-box;
    }
    .form-label,
    .filed-control {
      padding: 0 15px;
    }
    .setting-label {
      display: inline-block;
      vertical-align: middle;
    }
    .input-primary {
      color: #454545;
      border: 1px solid #d2d2d2;
      border-radius: 4px;
      background-color: #fff;
    }
    .input-style {
      display: block;
      width: 100%;
      height: 30px;
      padding: 6px 12px;
      font-size: 14px;
      font-weight: 400;
      box-shadow: none;
      box-sizing: border-box;
    }
    .select-primary {
      display: flex;
      align-items: center;
      width: 25%;
      height: 30px;
      padding: 4px;
      font-size: 14px;
      border-width: 1px;
      border-style: solid;
      border-color: #d2d2d2;
      border-radius: 4px;
      box-shadow: none;
      background-color: #fff;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
}
.button-group {
  margin-top: 30px;
  text-align: center;
  .button-grey, .button-green {
    padding: 5px 30px 5px 30px;
    color: #fff;
  }
  .button-grey {
    background-color: #bdbdbd;
    border-color: #bdbdbd;
    margin-right: 5px;
  }
  .button-green {
    background-color: #3dba90;
    border-color: #3dba90;
    margin-left: 5px;
  }
}

input {
  outline: none;
}
</style>
